var angular = require('angular');
var _ = require("underscore");
var types = require("../question-sets/types");

module.exports = angular.module('applicationQuestionDisplay', [])
                        .controller('ApplicationRegistrationQuestionsController', function ($scope) {

  $scope.setupConditions = function() {
    // loop through groups/questions to find comparers
    // and bind hide/show fn to a question change event.
    $scope.vm.questions.steps.forEach(function(step) {
      step.groups.forEach(function(group) {
        // set "hide" bool based on this group's comparers
        if (group.comparers) setupComparers(group);

        group.questions.forEach(function(question) {
          // set "hide" bool based on this question's comparers
          if (question.comparers) setupComparers(question);
        });
      });
    });

    function getQuestionById(id) {
      var foundQuestion = null;

      // look through all questions in all groups in all steps
      // if a matching question found, set foundQuestion to it
      $scope.vm.questions.steps.forEach(function(step) {
        step.groups.forEach(function(group) {
          group.questions.forEach(function(question) {
            if (question.id == id) foundQuestion = question;
          });
        });
      });

      return foundQuestion;
    }

    function setupComparers(target) {

      // question or group might have many comparers, for each one...
      target.comparers.forEach(function(comparer) {

        var comparerType = comparer.$type;
        var questionId = comparer.questionId;

        var question = getQuestionById(questionId);

        var type = types.comparers[comparerType];
        var bool = type.check(comparer, question);
        target.hide = !bool;
      });
    }
  };

  $scope.calculateTotal = function(q, qdata){
    var tableTotal = 0;
      if(qdata.length > 0){
        _.each(qdata, function (row) {
          tableTotal += parseFloat(row[1]);
        });
      }
      q.tableTotal = tableTotal;
    }


  $scope.setupConditions();
});
